<mat-card class="order-split-ui">
  <mat-stepper linear #stepper>
    <mat-step [editable]="isEditable" [stepControl]="orderSplitForm">
      <form [formGroup]="orderSplitForm">
        <ng-template matStepLabel>Number of orders</ng-template>
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Number of orders</mat-label>
            <input min="2" type="number" matInput placeholder="Number of orders" formControlName="numberOfOrders">
          </mat-form-field>
        </p>
        <div class="text-end mt-2">
          <button [disabled]="!orderSplitForm.valid" mat-raised-button color="primary" (click)="split()">
            <mat-icon>chevron_right</mat-icon> Next
          </button>
        </div>
      </form>
    </mat-step>
    <mat-step [editable]="isEditable">
      <ng-template matStepLabel>Distribute order items</ng-template>
      <div class="row">
        @for (split of splits; track split) {
          <div class="col-md-12 splits">
            <mat-card class="my-2">
              <mat-card-title>Order <strong>#{{split.id}}</strong></mat-card-title>
              <mat-divider></mat-divider>
              <mat-accordion [@.disabled]="disableAnimation" multi="true" class="mt-1" cdkDropList id="{{split.id}}" [cdkDropListData]="split.orderItems"
                [cdkDropListConnectedTo]="connectedTo" class="item-list" (cdkDropListDropped)="drop($event)">
                @for (item of split.orderItems; track item) {
                  <mat-expansion-panel [expanded]="false" cdkDrag>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ item.medicine.name }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{ item.dosageType.additional_information }} - {{item.status ? item.status.status : ''}}
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="content">
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Pack size</div>
                        <div class="col-md-6 text-end">{{item.medicineDosagePackageType.contained_quantity}}</div>
                      </div>
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Quantity</div>
                        <div class="col-md-6 text-end">{{item.quantity}}</div>
                      </div>
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Dosage type</div>
                        <div class="col-md-6 text-end">{{ item.dosageType.additional_information }}</div>
                      </div>
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Status</div>
                        <div class="col-md-6 text-end">{{item.status ? item.status.status : ''}}</div>
                      </div>
                      <mat-divider></mat-divider>
                    </div>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </mat-card>
          </div>
        }
      </div>
      <div class="text-end mt-2">
        <button color="primary" class="me-1" mat-raised-button matStepperPrevious>
          <mat-icon>chevron_left</mat-icon> Back
        </button>
        <button [disabled]="!isValid" color="primary" mat-raised-button (click)="save()">
          <mat-icon>save</mat-icon> Save
        </button>
      </div>
    </mat-step>
    <mat-step [editable]="isEditable">
      <ng-template matStepLabel>Done</ng-template>
      @for (newOrder of newOrders; track newOrder) {
        <div class="col-md-12 orders">
          <mat-card class="my-2">
            <mat-card-title>Order <strong>#{{newOrder.id}}</strong></mat-card-title>
            <mat-divider></mat-divider>
            <mat-card-content>
              <mat-accordion multi="true">
                @for (item of newOrder.order_items; track item) {
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ item.medicine_dosage_package_type.medicine_dosage_type.medicine.name }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{ item.medicine_dosage_package_type.medicine_dosage_type.additional_information }} - {{
                        item.status.status }}
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="content">
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Pack size</div>
                        <div class="col-md-6 text-end">{{item.medicine_dosage_package_type.contained_quantity}}</div>
                      </div>
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Quantity</div>
                        <div class="col-md-6 text-end">{{item.total_quantity}}</div>
                      </div>
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Dosage type</div>
                        <div class="col-md-6 text-end">{{
                        item.medicine_dosage_package_type.medicine_dosage_type.additional_information }}</div>
                      </div>
                      <mat-divider></mat-divider>
                      <div class="row py-2">
                        <div class="col-md-6">Status</div>
                        <div class="col-md-6 text-end">{{ item.status.status }}</div>
                      </div>
                      <mat-divider></mat-divider>
                    </div>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </mat-card-content>
            <mat-card-actions align="end">
              <button (click)="openOrder(newOrder)" mat-stroked-button color="primary">
                <mat-icon>open_in_new</mat-icon>
                Open
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      }
    </mat-step>
  </mat-stepper>
</mat-card>